import { getCurrentToken } from 'configs/api/token';
import { APP_ENVIROMENT } from 'configs/api/types';
import { useAuth } from 'lib/context';
import { getDefaultPromptUseCase } from 'lib/utils/functions';
import React from 'react';
import { CovideoMagicButton, PROMPT_TYPE } from 'react-covideo-ai-assist';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
// Adjust the type as needed

type MagicButtonProps = {
  userInput?: string;
  defaultPromptType: PROMPT_TYPE;
  handleSubmitGeneratedContent?: (generatedContent: string) => void;
  variant?: 'gradient' | 'secondary';
  margin?: string;
  iconColor?: string;
  hoverPosition?:
    | 'top'
    | 'bottom'
    | 'above'
    | 'bottom-left'
    | 'top-left'
    | 'right'
    | 'below'
    | undefined;
  hoverPopup?: JSX.Element;
  text?: string;
  defaultRecipient?: string;
  defaultVin?: string;
  videoId?: string;
  handleOnCopySuccess?: () => void;
  disabled?: boolean;
};

export const MagicButton: React.FC<MagicButtonProps> = ({
  variant = 'gradient',
  userInput,
  defaultPromptType,
  margin,
  iconColor,
  handleSubmitGeneratedContent,
  handleOnCopySuccess,
  hoverPosition,
  hoverPopup,
  text,
  defaultRecipient,
  defaultVin,
  videoId,
  disabled,
}) => {
  const history = useHistory();
  const { userData } = useAuth();
  const { i18n } = useTranslation();
  const defaultPromptUseCase = getDefaultPromptUseCase(userData.isAutomotive);

  const goToCompanySettings = () => {
    history.push(`/profile/Profile_EditCompanyInfo`);
  };

  return (
    <CovideoMagicButton
      disabled={disabled}
      handleOnCopySuccess={handleOnCopySuccess}
      videoId={videoId}
      defaultVin={defaultVin}
      defaultRecipient={defaultRecipient}
      margin={margin}
      hoverPopup={hoverPopup}
      hoverPosition={hoverPosition}
      text={text}
      iconColor={iconColor}
      userInput={userInput}
      defaultPromptType={defaultPromptType}
      defaultPromptUseCase={defaultPromptUseCase}
      handleSubmitGeneratedContent={handleSubmitGeneratedContent}
      variant={variant}
      token={getCurrentToken().token as string}
      userData={{
        customer: {
          business: userData.customer.business,
          hasCovideoMagic:
            userData?.customer?.hasCovideoMagic?.toString() === '1',
          markVideosAsSent: userData.customer.markVideosAsSent,
        },
        firstName: userData.firstName,
        isAutomotiveSalesRole: userData.isAutomotiveSalesRole,
        isAutomotiveServiceRole: userData.isAutomotiveServiceRole,
        isIMSEnabled: userData.isIMSEnabled,
        isAutomotive: userData.isAutomotive,
        isCompanyAdmin: userData.isCompanyAdmin,
        preferredLanguage: i18n.language,
      }}
      aiAssistTheme='branding'
      apiKey={process.env.REACT_APP_APIKEY}
      env={(process.env.REACT_APP_ENV as APP_ENVIROMENT) || 'production'}
      goToCompanySettings={goToCompanySettings}
    />
  );
};
